import * as React from "react";
import * as Palette from "../../../../palette";

export function buildInput(
  input: any,
  value: any,
  errors: string[],
  onChange: (id: string, value: any) => void,
  isDisabled: boolean
) {
  switch (input.input.type) {
    case "TextField":
      return (
        <Palette.TextField
          value={value}
          onChange={(event: any) => onChange(input.id, event.target.value)}
          errors={errors}
          isDisabled={isDisabled}
        />
      );
    case "TextAreaField":
      return (
        <Palette.TextAreaField
          value={value}
          onChange={(event: any) => onChange(input.id, event.target.value)}
          errors={errors}
          isDisabled={isDisabled}
        />
      );
    case "SelectField":
      const onSelectChange = (event: any) => {
        const nameIndex = input.input.names.findIndex(
          (v: any) => v === event.target.value
        );
        const value = input.input.values[nameIndex];
        onChange(input.id, value);
      };
      const valueIndex = input.input.values.findIndex((v: any) => v === value);
      return (
        <Palette.SelectField
          value={input.input.names[valueIndex]}
          values={input.input.names}
          errors={errors}
          onChange={onSelectChange}
          isDisabled={isDisabled}
        />
      );
    default:
      throw new Error(`Unknown input type ${input.id}`);
  }
}
